import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstEt0: [],
		et0: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getEt0(state) {
			return state.et0
		},
		getEt0etiq(state) {
			return state.et0.et0etiq
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, et0) {
			state.et0 = et0
			if (et0)
				state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.et0 = null
		},
		setParamsDataTable(state, payload) {
			state.lstEt0 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setEt0(state, et0) {
			state.et0 = et0
		},
		setLstEt0(state, lstEt0) {
			state.lstEt0 = lstEt0
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch }, et0etiq) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios.get(`/Products/Tag/Find/${et0etiq}`)
				.then(response => {
					let et0 = Utils.ValidateAxiosResponse(response.data);
					commit("set", et0)
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
				});
			commit("setLoading", false)
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios.post("/Products/Tag/Insert", getters.getEt0)
				.then(response => {
					commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
					commit("setEt0", null)
					return true
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios.put("/Products/Tag/Update", getters.getEt0)
				.then(response => {
					commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
					commit("setEt0", null)
					return true
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
			await this._vm.$axios.delete(`/Products/Tag/Delete/${getters.getEt0etiq}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data);
					router.push("/oryxpdv/etiquetas")
					return true
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList({ commit, getters, dispatch }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios.get(`/Products/Tag/FindList`)
				.then(response => {
					let lstEt0 = Utils.ValidateAxiosResponse(response.data);
					commit("setLstEt0", lstEt0)
					commit("setHasNext", lstEt0.length > getters.getItemsPerPage)
				}).catch(error => {
					commit("setLstEt0", [])
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				})
			commit("setLoading", false)
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios.get(`/Products/Tag/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data);
					commit("setParamsDataTable", payload)
					return true
				})
				.catch((error) => {
					commit("setLstEt0", [])
					commit("setSearch", "")
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			commit("setLoading", false)
			return payload
		},
	}
}